// Imports
import reframe from 'reframe.js';

// Project import
import CustomCursor from '@js/modules/CustomCursor';
import Modal from '@js/modules/Modal';

class Page {
    constructor() {}

    // Initialize the appear functionality
    init() {
        this.dynamicLoad();

        // Get current year for footer
        document.getElementById('ftr-year').innerHTML = new Date().getFullYear();
    }
    reinit() {
        this.dynamicLoad();
    }

    dynamicLoad() {
        /**
         * Reframe JS
         * Make elements like iframes scale at a fixed ratio
         */
        reframe('iframe');

        /**
         * Modal
         */
        Modal.init();

        // If the user does not have reduced motion settings in the browser
        if (!window.WAZZO.env.reducedMotion) {
            // Appear.init();
            // AppearGrid.init();
            // AppearParent.init();
        }


    }
}

export default new Page();
